<template>
  <div>
    <Alert class="mb-3" type="info">
      <span>
        If a user has already been added to the Atomic console through your SSO provider, but not to
        your organization, you can claim them here.
      </span>
    </Alert>
    <Form
      :onSubmit="claimUser"
      @success="onSuccess"
      @error="onError"
      submitButtonText="Save"
      v-slot="{ disabled }"
    >
      <div class="form-group">
        <label for="user-email">Email</label>
        <input
          id="user-email"
          type="email"
          class="form-control"
          v-model="user.email"
          placeholder="jappleseed@example.org"
          required
          :disabled="disabled"
        />
      </div>
      <UserRoleSelector
        v-if="!managesRolesInIdp"
        @selectionChanged="updateUserRole"
        :options="availableRoles"
      />
    </Form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserService from '@/services/UserService'
import { getAvailableUserRoles } from '@/lib/authorization'
import UserRoleSelector from '@/components/Shared/UserRoleSelector'
import Form from '@/components/MainContent/Form'
import Alert from '@/components/MainContent/Alert'

export default {
  name: 'UserAddForm',
  props: ['customerId'],
  components: {
    Alert,
    Form,
    UserRoleSelector,
  },
  computed: {
    ...mapGetters('customer', ['usesSso', 'managesRolesInIdp']),
  },
  data() {
    return {
      availableRoles: getAvailableUserRoles(),
      newUserRole: undefined,
      user: {
        email: undefined,
      },
    }
  },
  methods: {
    updateUserRole(role) {
      this.newUserRole = role
    },
    async claimUser() {
      const claimPayload = { email: this.user.email }
      claimPayload.roles = this.newUserRole ? [this.newUserRole] : []

      await UserService.claim(claimPayload)
    },
    onSuccess() {
      this.$analytics.track({
        event: 'Claim User',
        payload: {
          role: this.newUserRole,
        },
      })

      this.$toasted.success('User succesfully claimed')
      this.$router.push({ name: 'settings-team' })
    },
    onError() {
      this.$toasted.show('Error claiming user')
    },
  },
}
</script>
